import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";

import Vue from "vue";
import App from "./App";
import router from "./router";
import appInfo from "./app-info";
import "./registerServiceWorker";
import "./quasar";
import store from "./store";
import * as VueGoogleMaps from "vue2-google-maps";
import VueGeolocation from "vue-browser-geolocation";
import Localbase from "localbase";

let db = new Localbase("db");

//npm i vue2-google-maps

Vue.config.productionTip = false;
Vue.prototype.$appInfo = appInfo;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDE35BHw4UsWyGAzA4Gimr6pdleTvIbcs8",
    //key: "AIzaSyAJ05alJH5dsKJ1W1jTtgWAHSku4A3o_70",
    //
    libraries: "places",
  },
});

Vue.use(VueGeolocation);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
